// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3oUAn","info":"UpdateTermsInfo_info__2G8j_"};